import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preload',
  templateUrl: './preload.component.html',
  styles: []
})
export class PreloadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// F:/node/angular/complejidadesFrontend/src/app/components/preload/preload.component.ts